import styled from 'styled-components'

export const Style = styled.div`
  .container {
    display: flex;
    width: 96px;
    height: 93%;
    padding: 24px 16px 32px 16px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    flex-shrink: 0;
    border-right: 1px solid #292a3d;
    background: #1c1c28;
    transition: all 1s;

    &:hover {
      width: 240px;

      .container-label {
        width: 240px;
        display: flex;
        flex-direction: row;
      }

      .text-label {
        text-align: start;
        padding-right: 50px;
      }
    }
  }

  .tab-link {
    background: #252637;
    border-radius: 8px;

    &:active {
      text-decoration: none;
    }
  }

  .tab-link.active {
    background: #3b8ffd;
    text-decoration: none;
  }

  .container-label {
    text-decoration: none;
    display: flex;
    flex-direction: column;
    width: 95px;
    height: 80px;
    align-items: center;
    transition: all 0.9s;
  }

  .image-label {
    padding: 12px;
    width: 24px;
    height: 24px;
  }

  .text-label {
    overflow: hidden;
    color: #e8eaf6;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    text-transform: uppercase;
    text-overflow: ellipsis;
    letter-spacing: -0.11px;
    line-height: 26px;
  }
`
